import React from "react";
import { Formik, Field, Form } from "formik";
import { object } from "yup";
import { DatePicker } from "../../components/datetime-picker.component";
import { TextField } from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import { Typography, Paper } from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ConfirmDialog from "../../components/confirm.component";
import { Api } from "../../utils/api";

const validationSchema = object().shape({});
const styles = (theme) => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

class EmailValidator extends React.Component {
  state = {
    showAlert: false,
  };

  hasFiles = false;

  constructor() {
    super();
    this.api = new Api();
    this.handleFile = this.handleFile.bind(this);
    this.submissionConfirm = this.submissionConfirm.bind(this);
  }

  /**
   *
   */

  componentDidUpdate() {}

  /**
   *
   */

  handleFile(e, values) {
    this.hasFiles = true;
    //
    var file = e.target.files[0];
    values.attach_name = file.name;
    this.getBase64(file, (res) => {
      values.attach = res;
    });
  }

  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  closeAlert = () => {
    this.setState({ showAlert: false });
  };

  submissionConfirm(handleSubmit) {
    handleSubmit();
    this.closeAlert();
  }

  /**
   *
   */

  render() {
    const { request, classes, ie_client, entity } = this.props;

    return ie_client &&
      ie_client.id &&
      (ie_client.email ||
        (ie_client.preferred_contact && ie_client.preferred_contact.email)) &&
      entity &&
      entity.id &&
      request &&
      request.email ? (
      this.renderForm()
    ) : (
      <div>
        <CircularProgress className={classes.progress} color="primary" />
      </div>
    );
  }

  renderForm() {
    const {
      getForm,
      onSubmit,
      ie_client,
      entity,
      request,
      document_type,
      id,
      type,
      payment_at,
    } = this.props;

    const entity_email = entity.emails
      ? entity.emails
      : ie_client.preferred_contact
      ? ie_client.preferred_contact.email
      : ie_client.email;
    return (
      <>
        <Paper square>
          <Formik
            ref={(node) => getForm && getForm(node)}
            initialValues={{
              entity_email: entity_email,
              entity_name: ie_client.name,
              payment_at: payment_at,
              return_value: request.return_value,
              old_invoice_value: request.old_invoice_value,
              invoice_value: request.new_invoice_value,
              warranty: 90,
              total_days: request.total_days,
              invoice_status: request.old_invoice_status,
              invoice_type: type,
              observations: request.email,
              document_id: id,
              document_type: document_type,
            }}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnChange={false}
            validateOnBlur={false}
            render={({ values, handleSubmit, setFieldValue, isSubmitting }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Grid container style={{ width: "95%", margin: "auto" }}>
                    <Grid item md={4} style={{ marginRight: "50px" }}>
                      <Typography variant="h6" color="primary" gutterBottom>
                        Dados do Cliente
                      </Typography>
                      <Field
                        name="entity_name"
                        label="Entidade"
                        variant="outlined"
                        margin="normal"
                        type="text"
                        component={TextField}
                        onChange={setFieldValue}
                        value={"" + values.entity_name}
                        disabled
                        fullWidth
                      />
                      <Field
                        name="entity_email"
                        label="Email"
                        type="email"
                        variant="outlined"
                        margin="normal"
                        component={TextField}
                        onChange={setFieldValue}
                        value={"" + values.entity_email}
                        placeholder="Insira o emails de destino separados por ;"
                        required
                        fullWidth
                      ></Field>
                    </Grid>

                    {document_type === "invoice" ||
                      (document_type === "credit_note" &&
                        request.old_invoice_status === "final" && (
                          <>
                            <Grid item md={3} style={{ marginRight: "50px" }}>
                              <Typography
                                variant="h6"
                                color="primary"
                                gutterBottom
                              >
                                Dados da nova fatura
                              </Typography>

                              <Field
                                name="payment_at"
                                label="Data de Cobrança"
                                variant="outlined"
                                margin="normal"
                                component={DatePicker}
                                onChange={setFieldValue}
                                value={"" + values.payment_at}
                                fullWidth
                                disabled
                              />
                              <Field
                                name="invoice_value"
                                label="Valor (€)"
                                type="number"
                                variant="outlined"
                                margin="normal"
                                component={TextField}
                                onChange={setFieldValue}
                                value={values.invoice_value}
                                fullWidth
                                disabled
                              />
                            </Grid>
                          </>
                        ))}

                    {document_type === "credit_note" &&
                      request.old_invoice_status === "settled" && (
                        <>
                          <Grid item md={3}>
                            <Typography
                              variant="h6"
                              color="primary"
                              gutterBottom
                            >
                              Dados para estorno
                            </Typography>
                            <Field
                              name="old_invoice_value"
                              label="Valor inicial (€)"
                              type="number"
                              variant="outlined"
                              margin="normal"
                              component={TextField}
                              onChange={setFieldValue}
                              value={"" + values.old_invoice_value}
                              disabled
                              fullWidth
                            />
                            <Field
                              name="return_value"
                              label="Valor estorno (€)"
                              type="number"
                              variant="outlined"
                              margin="normal"
                              component={TextField}
                              onChange={setFieldValue}
                              value={"" + values.return_value}
                              disabled
                              fullWidth
                            />
                            <Field
                              name="total_days"
                              label="Nº dias de estadia"
                              type="number"
                              variant="outlined"
                              margin="normal"
                              component={TextField}
                              onChange={setFieldValue}
                              onKeyUp={(e) => this.setFinalValue(e, values)}
                              value={values.total_days}
                              disabled
                              fullWidth
                            />
                            <Typography
                              variant="caption"
                              color="primary"
                              gutterBottom
                            >
                              (Garantia: {values.warranty} dias)
                            </Typography>
                          </Grid>
                        </>
                      )}

                    {document_type === "invoice" && (
                      <Grid item md={10} style={{ marginTop: "20px" }}>
                        <Typography
                          variant="h6"
                          color="primary"
                          gutterBottom
                          style={{ marginTop: "20px" }}
                        >
                          Anexos
                        </Typography>
                        {request.attachments &&
                          request.attachments.links.map((url) => (
                            <div>
                              <a href={url} target="blank">
                                {url}
                              </a>
                            </div>
                          ))}
                      </Grid>
                    )}

                    <Grid item md={10} style={{ marginTop: "20px" }}>
                      <Typography
                        variant="h6"
                        color="primary"
                        gutterBottom
                        style={{ marginTop: "20px" }}
                      >
                        Observações
                      </Typography>
                      <Field
                        name="observations"
                        label="Observações"
                        variant="outlined"
                        margin="normal"
                        type="text"
                        component={TextField}
                        multiline
                        rows={30}
                        fullWidth
                        onChange={setFieldValue}
                        value={"" + values.observations}
                      />
                    </Grid>

                    {document_type === "credit_note" && (
                      <Grid>
                        <Grid item md={10}>
                          <input
                            type="file"
                            name="file"
                            onChange={(e) => {
                              this.handleFile(e, values);
                            }}
                          />
                        </Grid>
                        <Grid item md={10}>
                          <div className="credit-notes-required-field">
                            <label
                              hidden={
                                this.hasFiles ||
                                request.old_invoice_status === "final"
                              }
                            >
                              Campo obrigatório
                            </label>
                          </div>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>

                  <Paper style={{ textAlign: "right", marginTop: "40px" }}>
                    <Button
                      onClick={() => this.setState({ showAlert: true })}
                      color="primary"
                      style={{ marginRight: "20px", fontSize: "medium" }}
                    >
                      Enviar para cliente
                    </Button>
                  </Paper>

                  <ConfirmDialog
                    open={this.state.showAlert}
                    title={"Atenção"}
                    message={"Prosseguir com o envio do documento?"}
                    handleOk={() => this.submissionConfirm(handleSubmit)}
                    handleCancel={this.closeAlert}
                  ></ConfirmDialog>
                </Form>
              );
            }}
          />
        </Paper>
      </>
    );
  }
}

EmailValidator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EmailValidator);
